import React from 'react'
import { Box } from '@mui/material'

// Define keyframes animation for dots
const dotFlashingKeyframes = `
  @keyframes dotFlashing {
    0%, 80%, 100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
`

// Inject keyframes into document
if (typeof document !== 'undefined') {
  const styleId = 'processing-dots-keyframes'
  if (!document.getElementById(styleId)) {
    const styleSheet = document.createElement('style')
    styleSheet.id = styleId
    styleSheet.textContent = dotFlashingKeyframes
    document.head.appendChild(styleSheet)
  }
}

interface ProcessingTextProps {
  text: string
}
// Component for Processing text with animated dots
const ProcessingText: React.FC<ProcessingTextProps> = ({ text }) => {
  return (
    <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {text}
      <Box
        component='span'
        sx={{
          display: 'inline-block',
          ml: 0.5,
          '& span': {
            display: 'inline-block',
            animation: 'dotFlashing 1.4s infinite ease-in-out both',
            '&:nth-of-type(1)': {
              animationDelay: '-0.32s'
            },
            '&:nth-of-type(2)': {
              animationDelay: '-0.16s'
            }
          }
        }}>
        <Box component='span'>.</Box>
        <Box component='span'>.</Box>
        <Box component='span'>.</Box>
      </Box>
    </Box>
  )
}

export default ProcessingText
